<div class="alert-button">
<div class="alert-main">
    <span>{{text}}</span>
    <div class="fieldset">
      <core-helpers-forms-button [text]="buttonText" (submit)="onAction()"></core-helpers-forms-button>
    </div>
</div>
</div>
